import { render, staticRenderFns } from "./webhook.vue?vue&type=template&id=545af512&scoped=true&"
import script from "./webhook.vue?vue&type=script&lang=ts&"
export * from "./webhook.vue?vue&type=script&lang=ts&"
import style0 from "./webhook.vue?vue&type=style&index=0&id=545af512&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545af512",
  null
  
)

export default component.exports